import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "./AuthContext";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const { user } = useAuth();
  const [values, setValues] = useState({});
  const [editMode, setEditModeState] = useState(sessionStorage.getItem("zen_edit") === "1");
  const isAdmin = user?.role === "admin";

  useEffect(() => { api.get("/settings").then((r) => setValues(r.data)).catch(() => {}); }, []);

  const setEditMode = useCallback((on) => {
    sessionStorage.setItem("zen_edit", on ? "1" : "0");
    setEditModeState(on);
  }, []);

  const get = useCallback((k, d) => (k in values && values[k] !== null ? values[k] : d), [values]);

  const save = useCallback(async (k, v) => {
    setValues((prev) => ({ ...prev, [k]: v }));
    try {
      const { data } = await api.put("/admin/settings", { values: { [k]: v } });
      setValues(data);
      toast.success("Saved — live on the site.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }, []);

  const reset = useCallback(async (k) => {
    try {
      const { data } = await api.delete(`/admin/settings/${encodeURIComponent(k)}`);
      setValues(data);
      toast.success("Restored to original.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }, []);

  return (
    <SiteContext.Provider value={{ values, get, save, reset, isAdmin, editMode: isAdmin && editMode, setEditMode }}>
      {children}
    </SiteContext.Provider>
  );
}
